import { httpClient } from './http-client';
import type { ApiResponse } from './api.types';
import type { Categoria, CategoriaInput } from '../../modelos/Configuracion';

export const categoriaService = {
  getAll: (empresaId: string): Promise<ApiResponse<Categoria[]>> => {
    return httpClient.get('/categorias', { empresaId });
  },

  getById: (id: string): Promise<ApiResponse<Categoria>> => {
    return httpClient.get(`/categorias/${id}`);
  },

  create: (data: CategoriaInput): Promise<ApiResponse<Categoria>> => {
    return httpClient.post('/categorias', data);
  },

  update: (id: string, data: CategoriaInput): Promise<ApiResponse<Categoria>> => {
    return httpClient.put(`/categorias/${id}`, data);
  },

  delete: (id: string): Promise<ApiResponse<void>> => {
    return httpClient.delete(`/categorias/${id}`);
  },
};
